import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CanvasLayer } from '@y42/json-schema';
import { tap } from 'rxjs';
import {
  VisualizationCanvasElementQuery,
  VisualizationCanvasElementStore,
  VisualizationCanvasElementStoreModel,
} from '../../../state/canvas-element';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class CanvasZOrderService {
  constructor(
    readonly canvasElementQuery: VisualizationCanvasElementQuery,
    private readonly canvasElementStore: VisualizationCanvasElementStore,
  ) {
    canvasElementQuery.extremeZOrders$
      .pipe(
        tap((zOrders) => (this.extremeZOrders = zOrders)),
        untilDestroyed(this),
      )
      .subscribe();
  }

  private extremeZOrders!: { [layer: string]: { highest: number; lowest: number } };

  bringToFront(items: VisualizationCanvasElementStoreModel[]) {
    this.canvasElementStore.update(
      items.map((p) => p.$path),
      (entity: VisualizationCanvasElementStoreModel) => ({
        ...entity,
        zIndex: this.getHighestZOrder(entity.layer) + 1,
      }),
    );
  }

  sendToBack(items: VisualizationCanvasElementStoreModel[]) {
    this.canvasElementStore.update(
      items.map((p) => p.$path),
      (entity: VisualizationCanvasElementStoreModel) => ({
        ...entity,
        zIndex: this.getLowestZOrder(entity.layer) - 1,
      }),
    );
  }

  getHighestZOrder(layer: CanvasLayer = CanvasLayer.Default) {
    return this.extremeZOrders[layer]?.highest ?? 0;
  }

  getLowestZOrder(layer: CanvasLayer = CanvasLayer.Default) {
    return this.extremeZOrders[layer]?.lowest ?? 0;
  }
}
